<template>
  <div class="space-y-6">
    <div class="mx-auto rounded-md bg-white p-6 shadow-md">
      <div class="space-y-6">
        <div
          class="flex w-full cursor-pointer items-center justify-between"
          @click="showFiltersPane = !showFiltersPane"
        >
          <div class="flex items-center space-x-2">
            <OutlineAdjustmentsIcon class="h-7 w-7 text-gray-500" />
            <p class="text-base font-medium text-gray-500">Filtros</p>
          </div>

          <div>
            <CollapseToggle :isOpen="showFiltersPane" />
          </div>
        </div>

        <transition
          enter-active-class="transition-opacity duration-300 ease-in"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition-opacity duration-200 ease-out"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <form @submit.prevent="filter" class="space-y-8" v-show="showFiltersPane">
            <div class="space-y-4">
              <div class="flex items-center space-x-2">
                <p class="text-base font-medium text-gray-500">Solicitud</p>
              </div>

              <div
                class="grid grid-cols-1 gap-y-4 rounded-md lg:grid-cols-3 lg:gap-x-6 xl:gap-x-12"
              >
                <div class="flex items-center justify-between lg:justify-start lg:space-x-3">
                  <label for="tipoSolicitud" class="block text-sm font-medium text-gray-700">
                    Tipo
                  </label>

                  <select
                    id="tipoSolicitud"
                    class="block w-48 appearance-none text-sm transition duration-150 ease-in-out"
                    v-model="tipoSolicitud"
                  >
                    <option
                      v-for="(tipoSolicitud, index) in tiposSolicitudes"
                      :key="index"
                      :value="tipoSolicitud"
                    >
                      {{ tipoSolicitud.descripcion }}
                    </option>
                  </select>
                </div>

                <div class="flex items-center justify-between lg:justify-start lg:space-x-3">
                  <label for="fechaDesde" class="block text-sm font-medium text-gray-700">
                    Fecha desde
                  </label>

                  <div class="rounded-lg shadow-sm">
                    <datetime
                      class="theme-colescba"
                      type="date"
                      input-id="fechaDesde"
                      input-class="block w-48 text-sm transition duration-150 ease-in-out"
                      v-model="fechaDesde"
                      zone="UTC"
                      value-zone="UTC"
                      format="dd/MM/yyyy"
                      :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                    >
                    </datetime>
                  </div>
                </div>

                <div class="flex items-center justify-between lg:justify-start lg:space-x-3">
                  <label for="fechaHasta" class="block text-sm font-medium text-gray-700">
                    Fecha hasta
                  </label>

                  <div class="rounded-lg shadow-sm">
                    <datetime
                      class="theme-colescba"
                      type="date"
                      input-id="fechaHasta"
                      input-class="block w-48 text-sm transition duration-150 ease-in-out"
                      v-model="fechaHasta"
                      zone="UTC"
                      value-zone="UTC"
                      format="dd/MM/yyyy"
                      :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                    >
                    </datetime>
                  </div>
                </div>
              </div>
            </div>

            <div class="space-y-4">
              <div class="flex items-center">
                <p class="text-base font-medium text-gray-500">Datos del menor</p>
              </div>

              <div class="grid grid-cols-1 gap-y-6 lg:grid-cols-2 lg:gap-x-12">
                <div class="flex items-center justify-between lg:space-x-3">
                  <label for="menorTipoDocumento" class="block text-sm font-medium text-gray-700">
                    Tipo de documento
                  </label>

                  <select
                    id="menorTipoDocumento"
                    class="block w-48 appearance-none text-sm transition duration-150 ease-in-out md:w-96 lg:w-80"
                    v-model="menorTipoDocumento"
                  >
                    <option
                      v-for="(tipoDocumento, index) in tiposDocumento"
                      :key="index"
                      :value="tipoDocumento"
                    >
                      {{ tipoDocumento.descripcion }}
                    </option>
                  </select>
                </div>

                <div class="flex items-center justify-between md:space-x-3">
                  <label for="menorNumeroDocumento" class="block text-sm font-medium text-gray-700">
                    Nro. de documento
                  </label>

                  <input
                    id="menorNumeroDocumento"
                    type="text"
                    autocomplete="off"
                    class="block w-48 appearance-none text-sm transition duration-150 ease-in-out md:w-96 lg:w-80"
                    v-model="menorNumeroDocumento"
                  />
                </div>

                <div class="flex items-center justify-between md:col-start-1 md:space-x-3">
                  <label for="menorApellidos" class="block text-sm font-medium text-gray-700">
                    Apellidos
                  </label>

                  <input
                    id="menorApellidos"
                    type="text"
                    autocomplete="off"
                    class="block w-48 appearance-none text-sm transition duration-150 ease-in-out md:w-96 lg:w-80"
                    v-model="menorApellidos"
                  />
                </div>

                <div class="flex items-center justify-between md:space-x-3">
                  <label for="menorNombres" class="block text-sm font-medium text-gray-700">
                    Nombres
                  </label>

                  <input
                    id="menorNombres"
                    type="text"
                    autocomplete="off"
                    class="block w-48 appearance-none text-sm transition duration-150 ease-in-out md:w-96 lg:w-80"
                    v-model="menorNombres"
                  />
                </div>
              </div>
            </div>

            <div class="flex items-center justify-center space-x-3 md:justify-end">
              <span
                v-if="loading.results"
                key="form-searching-button"
                class="inline-flex w-full cursor-not-allowed items-center justify-center space-x-3 rounded-md bg-gray-300 px-5 py-2 text-sm font-medium uppercase tracking-wide transition duration-150 ease-in-out focus:outline-none md:w-auto"
              >
                <LoadingCircle class="h-5 w-5 text-gray-500" />
                <span class="text-gray-700">Buscando...</span>
              </span>

              <template v-else>
                <button
                  @click="clearFilters"
                  key="form-clear-button"
                  type="button"
                  class="inline-flex w-full items-center justify-center space-x-2 rounded-md bg-white px-5 py-2 text-sm font-medium uppercase tracking-wide text-colescba-blue-500 transition duration-150 ease-in-out hover:bg-white focus:outline-none focus:ring-1 focus:ring-colescba-blue-500 focus:ring-offset-1 md:w-auto"
                >
                  Limpiar
                </button>

                <button
                  type="submit"
                  key="form-filter-button"
                  class="inline-flex w-full items-center justify-center space-x-2 rounded-md bg-colescba-blue-500 px-5 py-2 text-sm font-medium uppercase tracking-wide text-white transition duration-150 ease-in-out hover:bg-colescba-blue-600 focus:outline-none focus:ring-1 focus:ring-colescba-blue-500 focus:ring-offset-1 md:w-auto"
                >
                  Filtrar
                </button>
              </template>
            </div>
          </form>
        </transition>
      </div>
    </div>
    <div class="mx-auto rounded-md bg-white p-6 shadow-md">
      <div v-if="loading.referenceData" class="flex flex-col items-center justify-center">
        <LoadingCircle class="h-32 w-32 text-gray-700" />
      </div>

      <div v-if="!loading.referenceData" class="space-y-4">
        <div v-if="loading.results" class="flex flex-col items-center justify-center">
          <LoadingCircle class="h-32 w-32 text-gray-700" />
        </div>

        <template v-else-if="solicitudes">
          <Empty v-if="solicitudes.total === 0" />

          <div v-else-if="solicitudes.data" class="space-y-4 px-4">
            <div ref="results">
              <SolicitudesTable :solicitudes="solicitudes.data" @change="filter()" />
            </div>

            <nav class="flex items-center justify-between bg-white px-4 py-3 sm:px-6">
              <div class="hidden sm:block">
                <p class="text-sm text-gray-700">
                  Mostrando
                  <span class="font-medium">{{ solicitudes.offsetStart }}</span>
                  a
                  <span class="font-medium">{{ solicitudes.offsetEnd }}</span>
                  de
                  <span class="font-medium">{{ solicitudes.total }}</span>
                  solicitudes
                </p>
              </div>

              <div class="flex flex-1 justify-between space-x-4 sm:justify-end">
                <button
                  @click="currentPage = currentPage - 1"
                  type="button"
                  class="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                  :class="
                    solicitudes.previousPage
                      ? 'bg-white hover:bg-gray-50'
                      : 'cursor-not-allowed bg-gray-100 opacity-50'
                  "
                  :disabled="!solicitudes.previousPage"
                >
                  <SolidChevronLeftIcon class="h-5 w-5" />
                  <span>Anterior</span>
                </button>

                <button
                  @click="currentPage = currentPage + 1"
                  type="button"
                  class="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                  :class="
                    solicitudes.nextPage
                      ? 'bg-white hover:bg-gray-50'
                      : 'cursor-not-allowed bg-gray-100 opacity-50'
                  "
                  :disabled="!solicitudes.nextPage"
                >
                  <span>Siguiente</span>
                  <SolidChevronRightIcon class="h-5 w-5" />
                </button>
              </div>
            </nav>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const FILTER_ALL_F = {
  id: '',
  descripcion: 'Todas',
}

const FILTER_ALL_M = {
  id: '',
  descripcion: 'Todos',
}

import { isFilterable } from '@/model'
import { paginate } from '@/util/array.util'
import Empty from '@/components/Core/Empty'
import CollapseToggle from '@/components/Core/CollapseToggle'

import { useSession } from '@colescba/ui'
import { useService } from '@colescba/app-vue'

export default {
  mixins: [useSession(), useService('api')],

  components: { Empty, CollapseToggle },

  data() {
    return {
      loading: {
        referenceData: false,
        results: false,
      },

      showFiltersPane: false,
      solicitudes: [],
      solicitudesResponse: [],
      currentPage: null,
      perPage: 10,
      tiposSolicitudes: [],
      tiposDocumento: [],

      tipoSolicitud: null,
      fechaDesde: null,
      fechaHasta: null,
      menorTipoDocumento: null,
      menorNumeroDocumento: '',
      menorApellidos: '',
      menorNombres: '',
    }
  },

  async mounted() {
    this.loading.referenceData = true

    try {
      const tiposDocumento = await this.api.referenceData.tiposDocumentos()

      this.tiposDocumento = [FILTER_ALL_M, ...tiposDocumento]
      this.menorTipoDocumento = FILTER_ALL_M

      let tiposSolicitudes = await this.api.referenceData.tiposSolicitudes()
      tiposSolicitudes = tiposSolicitudes.filter(each => isFilterable(each))

      this.tiposSolicitudes = [FILTER_ALL_F, ...tiposSolicitudes]
      this.tipoSolicitud = FILTER_ALL_F

      await this.filter()
    } finally {
      this.loading.referenceData = false
    }
  },

  computed: {
    searchParams() {
      return {
        desde: this.paramFechaApi(this.fechaDesde, { timezone: 'UTC' }),
        hasta: this.paramFechaApi(this.fechaHasta, { timezone: 'UTC' }),
        solicitudTipoId: this.tipoSolicitud.id,
        menorTipoDocumentoId: this.menorTipoDocumento.id,
        menorNumeroDocumento: this.menorNumeroDocumento,
        menorApellidos: this.menorApellidos,
        menorNombres: this.menorNombres,
      }
    },
  },

  methods: {
    clearFilters() {
      this.tipoSolicitud = FILTER_ALL_F
      this.fechaDesde = null
      this.fechaHasta = null
      this.menorTipoDocumento = FILTER_ALL_M
      this.menorNumeroDocumento = null
      this.menorApellidos = null
      this.menorNombres = null
    },

    async filter() {
      if (this.loading.results) return

      this.loading.results = true

      try {
        this.solicitudesResponse = await this.api.solicitudes.solicitudes(
          this.user,
          this.searchParams,
        )

        this.currentPage = 1
        this.updatePagination()
      } finally {
        this.loading.results = false
      }
    },

    scrollToResults() {
      if (this.$refs['results']) {
        setTimeout(() => this.$refs['results'].scrollIntoView({ behavior: 'smooth' }), 300)
      }
    },

    updatePagination() {
      this.solicitudes = paginate(this.solicitudesResponse, this.currentPage, this.perPage)
      //this.solicitudesResponse.paginate(this.currentPage, this.perPage)
      this.scrollToResults()
    },
  },

  watch: {
    currentPage() {
      this.updatePagination()
    },
  },
}
</script>
